/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/padding-line-between-statements */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Formik, Form } from "formik";
import {
	Alert,
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import TextInput from "src/components/input/TextInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useCambiarContrasenaMutation } from "src/redux/api/authApi";
import {
  esquemaDeValidacionRecuperarContrasena,
  valoresInicialesRecuperarContrasena,
} from "src/pages/cambio-contrasena/utils";

export type FormCambiarContrasenaProps = {
  token: string;
};

const FormCambiarContrasena = ({ token }: FormCambiarContrasenaProps) => {
  const [recuperarContrasena, { isSuccess }] = useCambiarContrasenaMutation();
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const [mostrarConfirmarContrasena, setMostrarConfirmarContrasena] =
    useState(false);

  const handleMostrarOcultarContrasena = () => {
    setMostrarContrasena(!mostrarContrasena);
  };

  const handleMostrarOcultarConfirmarContrasena = () => {
    setMostrarConfirmarContrasena(!mostrarConfirmarContrasena);
  };

  const onSubmit = (fields: any, setSubmitting: any) => {
    recuperarContrasena({ token, ...fields });
    setSubmitting(false);
  };
  if (isSuccess) {
    return (
		<Box
        sx={{
          width: "50%",
          minHeight: "100%",
		  height: "100vh",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: { xs: 0, md: 3 },
        }}
        data-testid="registro-exitoso"
      >
        <Card
          variant="elevation"
          sx={{
            minWidth: "350px",
            padding: 3,
            marginY: 3,
            marginX: { xs: 2, md: 0 },
          }}
        >
          <CardContent>
            <Typography variant="h5" component="div" gutterBottom align="left">
			Cambio de contraseña
            </Typography>
            <Typography variant="body1" gutterBottom align="left">
			Se ha cambiado la contraseña correctamente.
            </Typography>
			<br />
            <Link href="/jupiter" underline="hover">
              <Typography variant="body1" gutterBottom align="left">
                Iniciar sesión
              </Typography>
            </Link>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: { xs: "100%", lg: "50%" },
        minHeight: "100%",
		height: "100vh",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: { xs: 0, md: 3 },
      }}
    >
      <Card
        variant="elevation"
        sx={{
          minWidth: { xs: "85%" },
          padding: { xs: 2, md: 3 },
          marginY: 3,
          marginX: { xs: 3, md: 0 },
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            align="left"
            color="primary"
            sx={{ fontWeight: "bold" }}
          >
            Cambio de contraseña
            <br />
          </Typography>
          <Formik
            data-testid="formik-cambio-contrasena"
            initialValues={valoresInicialesRecuperarContrasena}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              onSubmit(values, setSubmitting);
            }}
            validationSchema={esquemaDeValidacionRecuperarContrasena}
          >
            {({ handleSubmit }) => (
              <Form
                onSubmit={handleSubmit}
                data-testid="formulario-cambio-contrasena"
              >
				 <Alert severity="info" sx={{textAlign: "left"}}>
          La contraseña debe cumplir con los criterios de una contraseña
          segura: Mínimo 8 caracteres, entre mayúsculas, minúsculas, números y un
          carácter no alfanumérico.
        </Alert>

		<br />
                <TextInput
                  data-testid="entrada-contrasena"
                  label="Contraseña"
                  name="contrasena"
                  type={mostrarContrasena ? "text" : "password"}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={handleMostrarOcultarContrasena}
                        edge="end"
                      >
                        {mostrarContrasena ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    ),
                  }}
                />
                <TextInput
                  data-testid="entrada-confirmar-contrasena2"
                  label="Verificación de contraseña"
                  name="confirmarContrasena"
                  type={mostrarConfirmarContrasena ? "text" : "password"}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={handleMostrarOcultarConfirmarContrasena}
                        edge="end"
                      >
                        {mostrarConfirmarContrasena ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    ),
                  }}
                />
                <br />
                <br />
                <Box>
                  <Button
                    data-testid="boton-cambiar-contrasena"
                    type="submit"
                    variant="contained"
					color="secondary"
                    sx={{
                      width: "100%",
                      borderRadius: "10px",
					  color: 'white',
                      padding: "10px",
                      "&:hover": {
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Cambiar contraseña
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FormCambiarContrasena;
